var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokopedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8682 14.6217C20.8082 14.1516 21.9495 13.895 22.9922 13.8059L24.1658 13.7032C25.4503 13.5925 26.7361 13.66 28.0219 13.66H28.7282V14.365C28.7282 17.4971 28.7282 20.6292 28.7282 23.7627V24.1219C28.7282 27.3553 26.0837 29.9998 22.849 29.9998H11V13.66H11.705C12.9935 13.66 14.2739 13.5763 15.5624 13.6749L16.7347 13.764C17.849 13.8477 18.8687 14.1179 19.8682 14.6217Z",
    fill: "#4D4C4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7051 14.3647V22.4145V23.7624V24.1216V29.2945H16.878H17.6897H22.849C25.6948 29.2945 28.0219 26.966 28.0219 24.1216V23.7624C28.0219 20.6478 28.0219 17.6103 28.0219 14.3647C26.7861 14.3647 25.4801 14.335 24.2267 14.4053L23.053 14.5066C21.905 14.647 20.7434 14.9145 19.8642 15.4223C18.9133 14.8739 17.8774 14.6011 16.6808 14.466L15.5084 14.3769C14.2294 14.3175 12.9179 14.3647 11.7051 14.3647Z",
    fill: "#5FB74E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.168 29.2947H16.8768H17.6885H22.8479C24.1093 29.2947 25.2668 28.8368 26.1663 28.0818C25.1156 25.6413 22.6885 23.9327 19.863 23.9327C16.5877 23.9327 13.85 26.2261 13.168 29.2947Z",
    fill: "#89C45F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8643 29.2948L22.9099 29.2489C24.1538 29.2489 25.2856 28.8113 26.1676 28.0819C27.3035 27.1446 28.022 25.7237 28.022 24.1219V23.7626C28.022 20.6481 28.022 17.6105 28.022 14.365C26.7862 14.365 25.4801 14.3353 24.2268 14.4055L23.0531 14.5068C21.905 14.6473 20.7435 14.9147 19.8643 15.4225V29.2948Z",
    fill: "#4A9E4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8643 29.2948H22.868C24.1295 29.2948 25.2681 28.8383 26.1676 28.082C25.129 25.6684 22.6492 23.9707 19.8643 23.9329V29.2948Z",
    fill: "#5FB74E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2261 13.9182C24.0019 11.7153 22.1407 10 19.8825 10C17.6229 10 15.7631 11.7004 15.5078 13.8898L16.6801 13.9803C16.8881 12.3987 18.2361 11.1764 19.8771 11.1764C21.5181 11.1764 22.8781 12.419 23.0524 14.0181L24.2261 13.9182Z",
    fill: "#4D4C4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7697 24.6201C21.2591 25.1604 20.7486 25.702 20.2381 26.2422L19.8626 26.6406L19.4871 26.2422C18.9752 25.702 18.4647 25.1604 17.9542 24.6201L17.6895 24.3392L17.8826 24.0056C18.2932 23.2992 19.059 22.9197 19.8626 22.9197C20.6649 22.9197 21.4307 23.2992 21.8413 24.0056L22.0344 24.3392L21.7697 24.6201Z",
    fill: "#4D4C4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3937 24.2663C20.8831 24.8066 20.3726 25.3468 19.8621 25.8884C19.3515 25.3468 18.8396 24.8066 18.3291 24.2663C18.6519 23.7098 19.257 23.4343 19.8621 23.4357C20.4658 23.4343 21.0709 23.7098 21.3937 24.2663Z",
    fill: "#FDF8B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3959 24.2664C20.8853 24.8067 20.3748 25.3469 19.8643 25.8885V23.4358C20.468 23.4344 21.0731 23.71 21.3959 24.2664Z",
    fill: "#FCD066"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0334 16.4001C18.3227 16.4001 20.1784 18.2573 20.1784 20.5452C20.1784 22.8332 18.3227 24.6903 16.0334 24.6903C13.744 24.6903 11.8896 22.8332 11.8896 20.5452C11.8896 18.2573 13.744 16.4001 16.0334 16.4001Z",
    fill: "#4D4C4B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0348 17.1056C17.9337 17.1056 19.4748 18.6466 19.4748 20.5456C19.4748 22.4446 17.9337 23.9843 16.0348 23.9843C14.1344 23.9843 12.5947 22.4446 12.5947 20.5456C12.5947 18.6466 14.1344 17.1056 16.0348 17.1056Z",
    fill: "#EEEFEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.036 17.1051C17.6041 17.1051 18.9264 18.1545 19.341 19.5889C18.9264 21.0233 17.6041 22.0727 16.036 22.0727C14.468 22.0727 13.1457 21.0233 12.7324 19.5889C13.1457 18.1545 14.468 17.1051 16.036 17.1051Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6929 16.4001C25.9822 16.4001 27.838 18.2573 27.838 20.5452C27.838 22.8332 25.9822 24.6903 23.6929 24.6903C21.405 24.6903 19.5479 22.8345 19.5479 20.5452C19.5479 18.2573 21.405 16.4001 23.6929 16.4001Z",
    fill: "#4D4C4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6897 17.1051C25.59 17.1051 27.1297 18.6462 27.1297 20.5451C27.1297 22.4441 25.59 23.9838 23.6897 23.9838C21.7907 23.9838 20.251 22.4441 20.251 20.5451C20.251 18.6462 21.7907 17.1051 23.6897 17.1051Z",
    fill: "#EEEFEE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6917 17.105C25.2598 17.105 26.5834 18.1544 26.9967 19.5888C26.5834 21.0231 25.2598 22.0726 23.6917 22.0726C22.1236 22.0726 20.8014 21.0231 20.3867 19.5888C20.8014 18.1544 22.1236 17.105 23.6917 17.105Z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4659 18.4058C17.6923 18.4058 18.6877 19.3998 18.6877 20.6262C18.6877 21.8539 17.6923 22.848 16.4659 22.848C15.2382 22.848 14.2441 21.8539 14.2441 20.6262C14.2441 20.2169 14.3562 19.8334 14.548 19.5052C14.7074 19.8968 15.091 20.1724 15.5407 20.1724C16.131 20.1724 16.6104 19.6943 16.6104 19.1027C16.6104 18.8366 16.5145 18.5948 16.3538 18.4085C16.3916 18.4058 16.4294 18.4058 16.4659 18.4058Z",
    fill: "#4D4C4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2608 18.4056C24.4885 18.4056 25.4826 19.3997 25.4826 20.6261C25.4826 21.8538 24.4885 22.8478 23.2608 22.8478C22.0345 22.8478 21.0391 21.8538 21.0391 20.6261C21.0391 20.2168 21.1498 19.8332 21.343 19.505C21.5023 19.8967 21.8873 20.1723 22.3357 20.1723C22.9272 20.1723 23.4053 19.6941 23.4053 19.1026C23.4053 18.8365 23.3095 18.5947 23.1487 18.4083C23.1865 18.4056 23.223 18.4056 23.2608 18.4056Z",
    fill: "#4D4C4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokopedia);
export default __webpack_public_path__ + "static/media/tokopedia.8162adfb99e82108ae77f85d49f5060d.svg";
export { ForwardRef as ReactComponent };